var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"merchant detail-page"},[(_vm.isFetchingMerchant)?_c('b-loading',{attrs:{"is-full-page":false,"active":""}}):_c('merchant-configuration',{attrs:{"merchant":_vm.merchant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }